import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

export default function Particles() {
  const particles = useMemo(() => {
    return Array.from({ length: 35 }).map((_, i) => ({
      id: i,
      size: Math.random() * 2.5 + 1, // small dust particles
      x: Math.random() * 100,
      y: Math.random() * 100,
      duration: Math.random() * 25 + 20, // slow movement
      delay: Math.random() * 10,
    }));
  }, []);

  return (
    <div className="absolute inset-0 pointer-events-none z-0 overflow-hidden">
      {particles.map((p) => (
        <motion.div
          key={p.id}
          className="absolute bg-brand-gold rounded-full opacity-0"
          style={{
            width: p.size,
            height: p.size,
            left: `${p.x}%`,
            top: `${p.y}%`,
            filter: 'blur(0.5px)',
            boxShadow: '0 0 4px rgba(201,162,39,0.4)'
          }}
          animate={{
            y: ['0vh', '-100vh'],
            x: ['0%', `${Math.random() * 10 - 5}%`],
            opacity: [0, 0.4, 0]
          }}
          transition={{
            duration: p.duration,
            repeat: Infinity,
            delay: p.delay,
            ease: "linear"
          }}
        />
      ))}
    </div>
  );
}